import React, { Component } from 'react';

export class Home extends Component {
    displayName = Home.name
    render() {
        let astyle = { color: "#003366", outline: "0px", border: "0px" };
        let pStyle = {
            margin: "0px", padding: "0px 0px 1em", fontFamily: "Helvetica, Arial, sans-serif", fontSize: "12px", lineHeight: "16px", backgroundColor: "#fafafa"
        };
        let arial = { "fontFamily": "Arial" };
        let emailLink = "mailto:DR@macu.com?Subject=MACUSOS&body=" + encodeURIComponent("This is the body of the email.");
        return (
            <div>
                <div className="body">
                    <div className="container">
                        <header className="header" role="banner">
                            <div className="header-inner clearfix">
                                <a className="brand pull-left" href="http://macusos.com/">
                                    <img src="./MACU_Logo1a.png" alt="MACU SOS" />
                                </a>
                                <div className="header-search pull-right">
                                </div>
                            </div>
                        </header>
                        <nav className="navigation" role="navigation">
                            <div className="nav-collapse">
                                <ul className="nav menu nav-pills">
                                    <li className="item-435 current active"><a href="/">Home</a></li>
                                    <li className="item-483"><a href={emailLink}>Contact Us</a></li>                                   
                                </ul>
                            </div>
                        </nav>
                        <div className="row-fluid">
                            <main id="content" role="main" className="span9">
                                <div className="moduletable span1">
                                    <div className="custom">
                                    </div>
                                </div>
                                <div id="system-message-container">
                                </div>
                                <div className="item-page" itemscope="" itemtype="https://schema.org/Article">
                                    <meta itemprop="inLanguage" content="en-GB" />
                                    <div itemprop="articleBody">
                                        <h3>What is MACU SOS?</h3>
                                        <p style={pStyle}><span style={arial}>MACU SOS is designed to share information with MACU employees in the event of an emergency. If an emergency were to occur the site would be updated frequently with instructions and information about the emergency, services and resources available to MACU employees.</span></p>
                                        <p style={pStyle}><span style={arial}>To access the MACU SOS content please click the "Login to MACU SOS" button. <b>You will then be redirected</b> to a login page where you can enter your MACU employee email address and password. If you are not an Employee you may use the shared email and login available to all friends and family of Employees.</span></p>
                                        <p style={pStyle}><span style={arial}>Information is also available at 1-877-MACU-SOS. When reporting an emergency make sure you give them your building location, floor and organization name. Emergencies that require immediate help from police, fire fighters or medical technicians, call 911. For non-emergencies please click&nbsp;</span>
                                            <a style={astyle} href="http://macusos.com/macusos/MessageBoard/tabid/81/aff/10/Default.aspx"><span style={arial}>here</span></a><span style={arial}>&nbsp;</span><span style={arial}>for a listing of numbers by state. All MACU employees should take steps to ensure their own safety and the safety of others in an emergency.&nbsp;</span></p>

                                        <p style={pStyle}>
                                            <em><span style={arial}>
                                                <br />
                                                <strong>*All website content is subject to the same policies and procedures found in the employee handbook regarding Communication and Information Systems</strong></span></em>
                                        </p>
                                    </div>
                                </div>
                            </main>
                            <div id="aside" className="span3">
                                <div className="well ">
                                    <div className="form-vertical">
                                        <div className="login-greeting">
                                            <div className="logout-button">
                                                <a href="https://mymacu.sharepoint.com/sites/macusos" className="btn btn-primary">Login to MACU SOS</a>
                                                <br/><br/>
                                                <p><i>Click the button above, to open the Login screen, in order to access the site content.</i></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer" role="contentinfo">
                    <div className="container">
                        <hr />
                        <p className="pull-right">
                            &nbsp;
                        </p>
                        <p>
                            &copy; 2024 MACU SOS
                        </p>
                    </div>
                </footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js